var map = {
	"./hsk_level1.png": 36889,
	"./hsk_level12.png": 4975,
	"./hsk_level13.png": 65958,
	"./hsk_level14.png": 99001,
	"./hsk_level2.png": 53954,
	"./hsk_level3.png": 44459,
	"./hsk_level4.png": 94548,
	"./hsk_level5.png": 15677,
	"./hsk_level6.png": 18118,
	"./hsk_level7.png": 99663,
	"./hsk_level8.png": 24856,
	"./hsk_level9.png": 45985,
	"./hskk_level1.png": 48804,
	"./hskk_level2.png": 85663,
	"./hskk_level3.png": 88726,
	"./spc/spc_level.png": 27001,
	"./yct_level1.png": 1771,
	"./yct_level2.png": 31920,
	"./yct_level3.png": 28825,
	"./yct_level4.png": 35750,
	"./yct_level5.png": 74767,
	"./yct_level6.png": 55860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25521;